"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rootDataForStackedContext = exports.StackedContext = void 0;
const react_1 = __importStar(require("react"));
const dynamic_1 = require("./dynamic");
const utils_1 = require("./utils");
class StackedContext {
    constructor(internalContext, key) {
        this.providerHelper = (input, __order, children, outValueHook) => {
            const prev = !outValueHook
                ? undefined
                : this.context
                    .useUnmodifiedRawValue();
            const increment = prev ? prev.prevRawValues.length : 0;
            const [mergedValue, compKey] = this.useMergeMeta({
                input,
                order: (typeof __order === "number"
                    ? __order > 0
                        ? __order + 1
                        : __order - 1
                    : 0) + increment,
                outHook: outValueHook,
                calc: undefined,
            }, prev);
            return react_1.default.createElement(this.providerHelper2, {
                mergedValue,
                key: compKey,
                children,
            });
        };
        this.providerHelper2 = ({ mergedValue, children, }) => {
            const calculatedValues = useCalculated(mergedValue);
            const deps = calculatedValues.concat([mergedValue]);
            const passingValue = react_1.useMemo(() => ({
                ...mergedValue,
                prevRawValues: mergedValue.prevRawValues.map((e, i) => i < mergedValue.ind
                    ? e
                    : { ...e, calc: calculatedValues[i - mergedValue.ind] }),
                calculatedValue: calculatedValues[calculatedValues.length - 1],
            }), deps);
            return react_1.default.createElement(this.originalProvider, this.key === null
                ? passingValue
                : { [this.key]: passingValue }, ...toArray(children));
        };
        this.useMergeMeta = (unMemoizedCurrent, prev) => {
            const current = utils_1.useMemoizedProps(unMemoizedCurrent);
            const prevRaws = (prev === null || prev === void 0 ? void 0 : prev.prevRawValues) || [];
            const newA = [...prevRaws, current];
            return react_1.useMemo(() => {
                const prevRawValues = [...newA].sort((a, b) => a.order - b.order);
                const elem = {
                    prevRawValues,
                    __$Stacked: true,
                    isAscending: getHighestOrder(prevRawValues) === current.order,
                    ind: prevRawValues.indexOf(current),
                };
                return [elem, generateCompKey(newA)];
            }, newA);
            // return outValueHook!(value, prev as any) as any;
        };
        this.context = internalContext;
        this.useValue = this.context.useValue;
        this.key = key === undefined ? "value" : key;
        const defaultValueGetter = (withMeta) => {
            return withMeta.prevRawValues[withMeta.prevRawValues.length - 1]
                .calc;
        };
        this.context.setRawValueModifiers(exports.rootDataForStackedContext, defaultValueGetter, defaultValueGetter);
        const originalProvider = this.context.Provider;
        this.originalProvider = originalProvider;
        if (typeof this.key !== "string") {
            this.context.Provider = this.addDestructuredProvider();
        }
        else {
            this.context.Provider = this.addProvider();
        }
        this.Provider = this.context.Provider;
    }
    static create(defaultValue, key, options) {
        const normalizedKey = typeof key === "string" ? key : "value";
        const dynamicContext = dynamic_1.DynamicContext.create(defaultValue === undefined
            ? undefined
            : exports.rootDataForStackedContext(defaultValue), normalizedKey, options);
        return new StackedContext(dynamicContext, normalizedKey);
    }
    static createDestructured(defaultValue, options) {
        const dynamicContext = dynamic_1.DynamicContext.createDestructured(defaultValue === undefined
            ? undefined
            : exports.rootDataForStackedContext(defaultValue), options);
        return new StackedContext(dynamicContext, null);
    }
    addProvider(outValueHook) {
        const component = ({ children, value, __order, }) => {
            return this.providerHelper(value, __order, children, outValueHook);
        };
        return component;
    }
    addDestructuredProvider(outValueHook) {
        const component = ({ children, __order, ...props }) => {
            const input = utils_1.useMemoizedProps(props);
            return this.providerHelper(input, __order, children, outValueHook);
        };
        return component;
    }
}
exports.StackedContext = StackedContext;
const getHighestOrder = (arr) => {
    let highest = -Infinity;
    for (let i = 0; i < arr.length; ++i) {
        if (arr[i].order > highest)
            highest = arr[i].order;
    }
    return highest;
};
const toArray = (el) => {
    if (Array.isArray(el))
        return el;
    return [el];
};
const generateCompKey = (elem) => {
    return elem.map(e => e.order).join("&");
};
exports.rootDataForStackedContext = (rawValue) => {
    return {
        prevRawValues: [
            { input: rawValue, order: -Infinity, isRoot: true, calc: rawValue },
        ],
        __$Stacked: true,
        ind: 0,
    };
};
const useCalculated = (meta) => {
    let value = undefined;
    let startIndex = 0;
    const elemns = meta.prevRawValues;
    if (meta.ind >= 1) {
        startIndex = meta.ind;
        value = elemns[meta.ind - 1].calc;
    }
    const values = [];
    for (let i = startIndex; i < elemns.length; ++i) {
        const elem = elemns[i];
        if (!elem.outHook) {
            value = elem.input;
        }
        else {
            value = elem.outHook(elem.input, value);
        }
        values.push(value);
    }
    return values;
};
